// extracted by mini-css-extract-plugin
export default {"Wrapper":"SurveyRecordVerifications_Wrapper__4teh8","SurveyRecordVerifications":"SurveyRecordVerifications_SurveyRecordVerifications__ipYpS"};